<template>
  <div class="maincont" id="multi-circuit-graph">
    <div class="multi-circuit-ef--inner graph-container">

      <div class="graph-header">
        <h2 class="graph-header-caption">グラフ</h2>
        <ul class="graph-header-button">
          <li class="graph-header-button-item auto-update-tooltip">
            <button @click="toggleAutoUpdate" id="auto-update-btn" class="bt">自動更新</button>
            <div class="auto-update-tooltip-description" id="auto-update-tooltip-description">現在、自動更新無効です。</div>
          </li>
          <li class="graph-header-button-item">
            <button @click="updateGraph" class="bt">グラフ更新</button>
          </li>
        </ul>
      </div>

      <div class="multi-circuit-graph-list">
        <p>グラフ選択</p>
        <span class="select-box">
          <select v-model="selectedGraph" id="view-graph" name="view-graph">
            <option v-for="(graph, index) in selectGraphList" :key="index" :value="graph.graphId">
              {{ graph.graphName }}
            </option>
          </select>
        </span>
      </div>

      <div class="graph-content">
        <div class="display-interval">
          <p>表示単位</p>
          <span class="select-display-interval">
            <input type="radio" value="月" v-model="selectInterval">
            <label>月</label>
            <input type="radio" value="日" v-model="selectInterval">
            <label>日</label>
            <input type="radio" value="時" v-model="selectInterval">
            <label>時</label>
            <input type="radio" value="30分" v-model="selectInterval">
            <label>30分</label>
            <input type="radio" value="分" v-model="selectInterval">
            <label>分</label>
          </span>
          <span id="display-interval-detail">{{ intervalDetail }}</span>
        </div>

        <div class="display-period">
          <p>表示範囲</p>
          <button @click="selectPeriod('period-month')" id="period-month" class="bt-period-disable">1ヵ月</button>
          <button @click="selectPeriod('period-weekly')" id="period-weekly" class="bt-period-disable">1週間</button>
          <button @click="selectPeriod('period-day')" id="period-day" class="bt-period-disable">1日</button>
          <button @click="selectPeriod('period-hour')" id="period-hour" class="bt-period-disable">1時間</button>
          <span class="select-date">
            <button @click="ctrlDate(0)" class="bt-date">&lt;</button>
            <input :type="periodInputType" v-model="periodStartDate" v-on:change="selectPeriod('-1')">
            <button @click="ctrlDate(1)" class="bt-date">&gt;</button>
            <p>~</p>
            <button @click="ctrlDate(2)" class="bt-date">&lt;</button>
            <input :type="periodInputType" v-model="periodEndDate" v-on:change="selectPeriod('-1')">
            <button @click="ctrlDate(3)" class="bt-date">&gt;</button>
          </span>
          <!-- グラフの線の太さ -->
          <p>線の幅 </p>
          <input type="range" min="1.0" max="3.0" step="0.5" v-model="selectBorderWidth" style="width: 50px;">
          <p> {{ selectBorderWidth }}</p>
        </div>

        <LineChart ref="lineChartRef" :chart-data="chartData" :options="chartOptions" :height="chartHeight"
          :width="chartWidth" style="margin-right: 10px;" />
        <ul class="weather" v-if="viewWeather" :style="{ marginLeft: dynamicMarginWeathers }">
          <li v-for="(item, index) in weathers" v-bind:key="index">
            <dl>
              <dt>
                <img v-bind:src="getWeatherIconUrl(item.weather)">
              </dt>
              <dd v-bind:class="getTempStyle(item.temperature)" v-if="item.temperature != undefined">
                <span>{{ item.temperature }}</span>℃
              </dd>
              <dd v-else v-bind:class="getTempStyle(item.temperature)">
                <span>&nbsp;</span>
              </dd>
            </dl>
          </li>
        </ul>

      </div>
    </div>
  </div>
</template>

<script>

import LineChart from "@/components/LineChart.vue";
import moment from "moment-timezone";

export default {
  name: "MultiCircuitGraph",

  components: {
    LineChart
  },

  data: function () {
    return {
      chartHeight: window.innerWidth * 0.33,
      chartWidth: window.innerWidth,
      chartData: { labels: [], datasets: [] },
      chartOptions: {},
      chartScaleY: {},
      graphItemSetting: {},
      scaleList: [],
      autoUpdateTime: 60000,
      autoUpdateId: null,
      selectedGraph: "",
      selectGraphList: [],
      selectInterval: null,
      intervalDetail: "",
      intervalDetailTextList: {
        "月": "",
        "日": "",
        "時": "表示単位 時: 過去1時間毎の集計値",
        "30分": "表示単位 30分: 過去30分毎の集計値",
        "分": "",
      },
      periodList: [
        "period-hour",
        "period-day",
        "period-weekly",
        "period-month",
      ],
      periodJpList: [
        "1時間",
        "1日",
        "1週間",
        "1か月",
      ],
      btPeriod: {
        enable: "bt-period-enable",
        disable: "bt-period-disable",
        inactive: "bt-period-inactive",
      },
      periodInputType: "datetime-local",
      periodStartDate: "",
      periodEndDate: "",
      selectBorderWidth: 2.0,
      graphData: [],
      defaultYAxisName: "default_Y_Axis_Id",
      viewWeather: false,
      weatherEnableIntervalList: ["日", "時", "30分", "分"],
      weathers: [],
      graphDataWeather: {},
      dynamicMarginWeathers: "",
      autoUpdateWeatherPositionId: null,
      autoUpdateWeatherPositionTime: 5000
    };
  },

  computed: {
  },

  watch: {
    selectedGraph: async function (newVal) {
      await this.getGraphItemSetting(newVal);
      await this.setScale();

      // 表示単位（ラジオボタン）初期選択
      this.selectInterval = this.graphItemSetting.initInterval;

      // 表示範囲を設定して時刻を設定する処理
      const selectedPeriodIndex = this.periodJpList.findIndex(item => item === this.graphItemSetting.initPeriod);
      this.selectPeriod(this.periodList[selectedPeriodIndex]);

      this.updateGraph();
    },
    selectInterval: function (newVal, oldVal) {
      if (newVal !== "月") {
        this.periodInputType = "datetime-local";
        if (oldVal === "月") {
          const tmpStartDate = new Date(this.monthToDateTimeLocal(this.periodStartDate));
          this.periodStartDate = this.generationDateStr(tmpStartDate);
          const tmpEndDate = new Date(this.monthToDateTimeLocal(this.periodEndDate));
          this.periodEndDate = this.generationDateStr(tmpEndDate);
          document.getElementById("period-month").className = this.btPeriod.disable;
        }
      } else {
        this.periodInputType = "month";
        this.periodStartDate = this.dateTimeLocalToMonth(this.periodStartDate);
        this.periodEndDate = this.dateTimeLocalToMonth(this.periodEndDate);
      }
      this.intervalDetail = this.intervalDetailTextList[newVal];
      this.toggeleDisplayIntervalButton(newVal);
    }
  },

  mounted: function () {
    this.getGraphInfoList();
  },

  methods: {
    /* グラフ一覧取得API */
    getGraphInfoList: async function () {
      await this.$axios
        .get(`/srv/api/multi_circuit_graph_info_list/${this.$store.state.loginID}`, {
          withCredentials: true
        })
        .then(response => {
          this.selectGraphList = response.data.multi_circuit_graphinfo_list;

          if (this.selectGraphList.some(graph => graph.graphId === this.$store.state.graphID)) {
            // グラフ一覧のグラフ表示ボタンのID
            this.selectedGraph = this.$store.state.graphID;
          } else {
            // グラフ選択で一番上を選択する処理
            this.selectedGraph = this.selectGraphList[0].graphId;
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    },

    /* グラフ個別設定情報取得 */
    getGraphItemSetting: async function (graphId) {
      await this.$axios
        .get(`/srv/api/multi_circuit_graph_item_setting/${this.$store.state.loginID}/${graphId}`, {
          withCredentials: true,
        })
        .then(response => {
          this.graphItemSetting = response.data;
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    },

    /* スケールグループ取得API */
    postGraphScaleGroup: async function () {
      await this.$axios
        .post(`/srv/api/multi_circuit_graph_scale_group/${this.$store.state.loginID}`, {
          "graphId": this.selectedGraph
        }, {
          withCredentials: true,
        })
        .then(response => {
          this.scaleList = response.data.scalegroupinfo_list;
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    },

    /* グラフデータ */
    postGraphData: async function (interval, startDate, endDate, graphItemList) {
      const params = {
        interval: interval,
        startDate: startDate,
        endDate: endDate,
        graphId: this.selectedGraph,
        graphItem: graphItemList
      };
      await this.$axios
        .post(`/srv/api/multi_circuit_graph_data/${this.$store.state.loginID}`, params, {
          withCredentials: true,
        })
        .then(response => {
          this.graphData = response.data.graphItem;
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    },

    /* 天気データ取得処理 */
    postGraphDataWeather: async function (graphId, startDate, endDate) {
      // 開始時刻と終了時刻の期間を12分割してパラメータを作成
      const startTime = new Date(startDate);
      const endTime = new Date(endDate);
      const division = 12;
      const diffTime = (endTime - startTime) / division;
      const timeArray = [];
      for (let i = 0; i < division + 1; i++) {
        const time = new Date(startTime.getTime() + (diffTime * i));
        timeArray.push(time);
      }

      const params = {
        graphId: graphId,
        dateList: timeArray,
      };
      await this.$axios
        .post(`/srv/api/multi_circuit_graph_data/weather/${this.$store.state.loginID}`, params, {
          withCredentials: true,
        })
        .then(response => {
          this.graphDataWeather = response.data.weather;

          let weathers = Array(13).fill({
            weather: undefined,
            temperature: undefined
          });
          for (let i = 0; i < division + 1; i++) {
            weathers[i] = {
              weather: this.graphDataWeather[i].weather,
              temperature: this.graphDataWeather[i].temperature
            };
          }
          this.weathers = weathers;
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    },

    /* 自動更新切替処理 */
    toggleAutoUpdate: function () {
      const autoUpdateValue = document.getElementById("auto-update-btn").className;
      if (autoUpdateValue === "bt") {
        document.getElementById("auto-update-btn").className = "bt-enable";
        document.getElementById("auto-update-tooltip-description").innerHTML = "現在、自動更新有効です。";
        this.autoUpdateId = setInterval(() => {
          this.updateGraph();
        }, this.autoUpdateTime);
      } else if (autoUpdateValue === "bt-enable") {
        document.getElementById("auto-update-btn").className = "bt";
        document.getElementById("auto-update-tooltip-description").innerHTML = "現在、自動更新無効です。";
        clearInterval(this.autoUpdateId);
      }
    },

    /* グラフ更新処理 */
    updateGraph: async function () {
      if (this.checkPeriod()) {
        this.$store.dispatch("setGraphID", this.selectedGraph);
        this.chartOptions = this.setOptions(this.selectInterval, this.periodStartDate, this.periodEndDate);
        this.fillData(this.selectInterval, this.periodStartDate, this.periodEndDate);

        if (this.graphItemSetting.weatherAreaName !== null
          && this.graphItemSetting.weatherAreaName !== ""
          && this.weatherEnableIntervalList.includes(this.selectInterval)) {

          await this.postGraphDataWeather(this.graphItemSetting.graphId, this.periodStartDate, this.periodEndDate);

          this.autoUpdateWeatherPositionId = setInterval(() => {
            try {
              this.updateWeatherPosition();
            } catch (error) {
              clearInterval(this.autoUpdateWeatherPositionId);
            }
          }, this.autoUpdateWeatherPositionTime);
          this.viewWeather = true;
        } else {
          this.weathers = Array(13).fill({
            weather: undefined,
            temperature: undefined
          });
          clearInterval(this.autoUpdateWeatherPositionId);
          this.viewWeather = false;
        }
      }
    },

    /* 天気表示の位置調整 */
    updateWeatherPosition: function () {
      let weathersWidth = 0;
      const scaleObj = this.$refs.lineChartRef.$data._chart.scales;
      for (const key of Object.keys(scaleObj)) {
        if (key === "x-axis-0") {
          weathersWidth = scaleObj[key]._startPixel - 20;
        }
      }
      this.dynamicMarginWeathers = weathersWidth + "px";
    },

    /* 表示範囲が既定より超えているか確認する処理 */
    checkPeriod: function () {
      const ONE_DAY = 1000 * 60 * 60 * 24; // 1日の値
      const PERIOD_MAX_DAY_LIST = { "月": 365, "日": 180, "時": 31, "30分": 31, "分": 10 }; // 各表示単位の最大日数

      let alertMessage = "表示範囲を正しく設定してください。\n";
      const startDate = new Date(this.periodStartDate);
      const endDate = new Date(this.periodEndDate);
      if (isNaN(startDate) || isNaN(endDate)) {
        alert(alertMessage + "(時刻が正しく入力されていない)");
        return false;
      }
      if (startDate > endDate) {
        alert(alertMessage + "(開始時刻が終了時刻を超えている)");
        return false;
      }
      const periodDate = endDate - startDate;
      const diff = periodDate / (ONE_DAY * PERIOD_MAX_DAY_LIST[this.selectInterval] + 1000 * 60);
      if (diff >= 1) {
        if (this.selectInterval !== "月") {
          const errorMessage =
            "(表示単位 " + this.selectInterval + " 最大:" + PERIOD_MAX_DAY_LIST[this.selectInterval] + "日間)";
          alert(alertMessage + errorMessage);
        } else {
          const errorMessage =
            "(表示単位 " + this.selectInterval + " 最大:12ヵ月)";
          alert(alertMessage + errorMessage);
        }
        return false;
      }
      return true;
    },

    /* スケール情報設定処理*/
    setScale: async function () {
      await this.postGraphScaleGroup();

      const scales = { yAxes: [] };
      let scaleList = this.scaleList;
      if (this.graphItemSetting.graphItemSettings.some(obj => obj.scaleGroupName === null)) {
        const defaultScale = {
          "scaleGroupName": this.defaultYAxisName,
          "isAutoScale": true,
          "fixedScaleMin": "0.0",
          "fixedScaleMax": "0.0",
          "unitName": "",
        };
        scaleList.unshift(defaultScale);
      }
      for (let i = 0; i < scaleList.length; i++) {
        if (this.graphItemSetting.graphItemSettings.some(obj => obj.scaleGroupName === scaleList[i].scaleGroupName)
          || scaleList[i].scaleGroupName === this.defaultYAxisName) {
          const yAxes = {
            id: scaleList[i].scaleGroupName,
            type: "linear",
            position: "left",
            ticks: {
              callback: function (value, index,) {
                if (index === 0) {
                  if (scaleList[i].unitName != "") {
                    return scaleList[i].unitName;
                  }
                }
                let decimalPlaces = (scaleList[i].fixedScaleMin.toString().split('.')[1] || '').length;
                if (decimalPlaces < (scaleList[i].fixedScaleMax.toString().split('.')[1] || '').length) {
                  decimalPlaces = (scaleList[i].fixedScaleMax.toString().split('.')[1] || '').length;
                }
                return value.toFixed(decimalPlaces);
              },
            },
            gridLines: {
              drawOnChartArea: i === 0
            },
          };
          if (!scaleList[i].isAutoScale) {
            yAxes.ticks.min = parseFloat(scaleList[i].fixedScaleMin);
            yAxes.ticks.max = parseFloat(scaleList[i].fixedScaleMax);
          }
          scales.yAxes.push(yAxes);
        }
      }
      this.chartScaleY = scales.yAxes;
    },

    /* X軸ラベル作成 */
    createLabel: function (interval, start, end) {
      const label = [];

      if (interval === "月") {
        const current = new Date(this.monthToDateTimeLocal(start));
        const endDate = new Date(this.monthToDateTimeLocal(end));
        // while (current <= endDate) {
        label.push(current.toLocaleString());
        label.push(endDate.toLocaleString());
        // current.setMonth(current.getMonth() + 1);
        // }
      } else {
        const current = new Date(start);
        const endDate = new Date(end);
        if (interval === "日") {
          while (current <= endDate) {
            label.push(current.toLocaleString());
            current.setDate(current.getDate() + 1);
          }
        } else if (interval === "時") {
          while (current <= endDate) {
            label.push(current.toLocaleString());
            current.setHours(current.getHours() + 1);
          }
        } else if (interval === "30分") {
          while (current <= endDate) {
            label.push(current.toLocaleString());
            current.setMinutes(current.getMinutes() + 30);
          }
        } else if (interval === "分") {
          while (current <= endDate) {
            label.push(current.toLocaleString());
            current.setMinutes(current.getMinutes() + 1);
          }
        }
      }

      return label;
    },

    /* グラフデータ作成 */
    createDatasets: function () {
      let datasets = [];
      for (let i = 0; i < this.graphItemSetting.graphItemSettings.length; i++) {
        let pointRadius = 0; // ツールチップの有効無効にかかわる
        let pointHitRadius = 0; // ツールチップの有効無効にかかわる
        if (this.graphItemSetting.graphItemSettings[i].isTooltip) {
          pointRadius = this.selectBorderWidth;
          pointHitRadius = 1.5;
        }
        let unit = false;
        const unit_index = this.scaleList.find((y) =>
          y.scaleGroupName == this.graphItemSetting.graphItemSettings[i].scaleGroupName
        );
        if (unit_index) {
          unit = unit_index.unitName;
        }
        let yAxisID = this.graphItemSetting.graphItemSettings[i].scaleGroupName;
        if (!yAxisID) {
          yAxisID = this.defaultYAxisName;
        }
        if (this.graphItemSetting.graphItemSettings[i].graphKind === "棒") {
          datasets.push({
            type: "bar",
            label: this.graphItemSetting.graphItemSettings[i].dataName,
            data: this.graphData[i].data,
            order: 2,
            backgroundColor: this.graphItemSetting.graphItemSettings[i].graphColor,
            borderColor: this.graphItemSetting.graphItemSettings[i].graphColor,
            borderWidth: this.selectBorderWidth,
            lineTension: 0,
            spanGaps: true,
            tooltip: this.graphItemSetting.graphItemSettings[i].isTooltip,
            yAxisID: yAxisID,
            unit: unit,
            pointRadius: pointRadius,
            pointHitRadius: pointHitRadius
          });
        } else {
          datasets.push({
            label: this.graphItemSetting.graphItemSettings[i].dataName,
            data: this.graphData[i].data,
            order: 1,
            backgroundColor: 'rgba(255, 255, 255, 0)',
            borderColor: this.graphItemSetting.graphItemSettings[i].graphColor,
            borderWidth: this.selectBorderWidth,
            lineTension: 0,
            spanGaps: true,
            tooltip: this.graphItemSetting.graphItemSettings[i].isTooltip,
            yAxisID: yAxisID,
            unit: unit,
            pointRadius: pointRadius,
            pointHitRadius: pointHitRadius
          });
        }
      }
      return datasets;
    },

    /* 表示単位切り替え処理 */
    toggeleDisplayIntervalButton: function (newIntervalRadioBtnValue) {
      for (const elementId of this.periodList) {
        const periodBtn = document.getElementById(elementId);
        if (periodBtn.className === this.btPeriod.inactive) {
          periodBtn.className = this.btPeriod.disable;
        }
      }

      /* 表示単位「月」の時の表示範囲ボタンの有効無効 */
      if (newIntervalRadioBtnValue === "月") {
        for (let index = 0; index < 3; index++) {
          const periodBtn = document.getElementById(this.periodList[index]);
          if (periodBtn.className === this.btPeriod.enable) {
            this.selectPeriod(this.periodList[3]);
          }
          periodBtn.className = this.btPeriod.inactive;
        }
      }

      /* 表示単位「日」の時の表示範囲ボタンの有効無効 */
      if (newIntervalRadioBtnValue === "日") {
        const periodBtn = document.getElementById(this.periodList[0]);
        if (periodBtn.className === this.btPeriod.enable) {
          this.selectPeriod(this.periodList[1]);
        }
        periodBtn.className = this.btPeriod.inactive;
      }

      /* 表示単位「分」の時の表示範囲ボタンの有効無効 */
      if (newIntervalRadioBtnValue === "分") {
        const periodBtn = document.getElementById(this.periodList[3]);
        if (periodBtn.className === this.btPeriod.enable) {
          this.selectPeriod(this.periodList[0]);
        }
        periodBtn.className = this.btPeriod.inactive;
      }
    },

    /* 表示範囲切り替え処理 */
    selectPeriod: function (period) {
      /* 有効状態の表示範囲ボタン無効にする */
      for (const elementId of this.periodList) {
        const periodBtn = document.getElementById(elementId);
        if (periodBtn.className === this.btPeriod.enable) {
          periodBtn.className = this.btPeriod.disable;
        }
      }
      if (this.periodList.includes(period)) {
        document.getElementById(period).className = this.btPeriod.enable;
        this.resetDate(period);
      }
    },

    /* 表示範囲日付の設定処理 */
    resetDate: function (period) {
      this.periodEndDate = this.generationDateStr(new Date(Date.now()));
      const startDate = new Date(this.periodEndDate);
      if (period === this.periodList[0]) {
        startDate.setHours(startDate.getHours() - 1);
      } else if (period === this.periodList[1]) {
        startDate.setDate(startDate.getDate() - 1);
      } else if (period === this.periodList[2]) {
        startDate.setDate(startDate.getDate() - 7);
      } else if (period === this.periodList[3]) {
        startDate.setMonth(startDate.getMonth() - 1);
      }
      this.periodStartDate = this.generationDateStr(startDate);
    },

    /* 表示範囲の日付の上下ボタンの処理 */
    ctrlDate: function (selectBtn) {
      this.selectPeriod("-1");
      const date = selectBtn < 2 ? this.periodStartDate : this.periodEndDate;
      const currentDate = date ? new Date(date) : new Date(Date.now());
      const operation = selectBtn % 2 === 0 ? -1 : 1;
      if (this.selectInterval !== "月") {
        currentDate.setDate(currentDate.getDate() + operation);
      } else {
        currentDate.setMonth(currentDate.getMonth() + operation);
      }
      if (selectBtn < 2) {
        this.periodStartDate = this.generationDateStr(currentDate);
      } else {
        this.periodEndDate = this.generationDateStr(currentDate);
      }
    },

    /* Date型をHTMLのinput形式に変換する処理 */
    generationDateStr: function (date) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");
      if (this.selectInterval !== "月") {
        return `${yyyy}-${mm}-${dd}T${hour}:${minute}`;
      } else {
        return `${yyyy}-${mm}`;
      }
    },

    /* 月の時の日付を他の単位の日付に変更する処理 */
    monthToDateTimeLocal: function (dateStr) {
      const date = new Date(dateStr);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      return `${yyyy}-${mm}-01T00:00:00`;
    },

    /* 他の単位の日付を月の時の日付に変更する処理 */
    dateTimeLocalToMonth: function (dateStr) {
      const date = new Date(dateStr);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      return `${yyyy}-${mm}`;
    },

    /* 表示単位 30分時のX軸補正用の日付処理 */
    roundTimeToNearestHalfHour: function (dateStr) {
      const date = new Date(dateStr);
      const minutes = date.getMinutes();
      if (minutes < 30) {
        date.setMinutes(0);
      } else if (minutes < 60) {
        date.setMinutes(30);
      }
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}T${hour}:${minute}`;
    },


    /* グラフオプション設定値呼び出し */
    setOptions: function (interval, start, end) {
      let minuteFormats = 'HH:mm';
      let timeUnit = null;
      let stepSize = 1;
      let adjustTime = 1;
      let adjustInterval = 'm';
      if (interval === "30分") {
        start = this.roundTimeToNearestHalfHour(start);
        minuteFormats = 'HH:mm';
        timeUnit = "minute";
        stepSize = 30;
        adjustTime = 30;
        adjustInterval = 'm';
      } else if (interval === "時") {
        timeUnit = "hour";
        adjustTime = 1;
        adjustInterval = 'h';
      } else if (interval === "日") {
        timeUnit = "day";
        adjustTime = 1;
        adjustInterval = 'd';
      } else if (interval === "月") {
        adjustTime = 1;
        adjustInterval = 'M';
      }
      let startLabel = moment(start).subtract(adjustTime, adjustInterval).format('YYYY-MM-DD HH:mm:SS');
      let endLabel = moment(end).add(adjustTime, adjustInterval).format('YYYY-MM-DD HH:mm:SS');

      let xAxes = [{
        type: 'time',
        time: {
          unit: timeUnit,
          displayFormats: {
            millisecond: 'HH:mm',
            second: 'HH:mm',
            minute: minuteFormats,
            hour: 'M/D HH:mm',
            day: 'M/D'
          },
          stepSize: stepSize
        },
        ticks: {
          min: startLabel,
          max: endLabel,
          autoSkip: true,
          maxTicksLimit: 30,
        },
      }];

      let callbacks = {
        title: function (tooltipItem) {
          const date = new Date(tooltipItem[0].xLabel);
          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");
          const hour = String(date.getHours()).padStart(2, "0");
          const minute = String(date.getMinutes()).padStart(2, "0");
          return `${yyyy}/${mm}/${dd} ${hour}:${minute}`;
        },
        label: function (tooltipItem, data) {
          if (data.datasets[tooltipItem.datasetIndex].tooltip) {
            let unit = "";
            if (data.datasets[tooltipItem.datasetIndex].unit) {
              unit = " (" + data.datasets[tooltipItem.datasetIndex].unit + ")";
            }
            return " " + data.datasets[tooltipItem.datasetIndex].label + unit + " : " +
              data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
          } else {
            return;
          }
        }
      };

      if (interval === "月") {
        xAxes = [{
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'Y/M'
            },
          },
          ticks: {
            min: this.monthToDateTimeLocal(startLabel).slice(0, 16),
            max: this.monthToDateTimeLocal(endLabel).slice(0, 16),
            autoSkip: false,
            maxRotation: 0,
            minRotation: 0,
          }
        }];

        callbacks = {
          title: function (tooltipItem) {
            return tooltipItem[0].xLabel.slice(0, 7).replace('-', '/');
          },
          label: function (tooltipItem, data) {
            if (data.datasets[tooltipItem.datasetIndex].tooltip) {
              let unit = "";
              if (data.datasets[tooltipItem.datasetIndex].unit) {
                unit = " (" + data.datasets[tooltipItem.datasetIndex].unit + ")";
              }
              return " " + data.datasets[tooltipItem.datasetIndex].label + unit + " : " +
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
            } else {
              return;
            }
          }
        };
      }

      const scales = {
        xAxes: xAxes,
        yAxes: this.chartScaleY
      };

      return {
        animation: false,
        legend: {
          display: true,
          position: "top",
          labels: {
            Color: "#000",
            boxWidth: 12,
          },
        },
        tooltips: {
          mode: 'label',
          position: 'nearest',
          callbacks: callbacks
        },
        scales: scales,
      };
    },

    /* グラフ描画 */
    fillData: async function (interval, start, end) {
      let labels = this.createLabel(interval, start, end);
      let graphItemList = [];
      for (let i = 0; i < this.graphItemSetting.graphItemSettings.length; i++) {
        graphItemList.push({
          graphItemId: this.graphItemSetting.graphItemSettings[i].graphItemId,
          areaId: this.graphItemSetting.graphItemSettings[i].areaId,
          clusterId: this.graphItemSetting.graphItemSettings[i].clusterId,
          dataCode: this.graphItemSetting.graphItemSettings[i].dataCode
        });
      }
      if (this.selectInterval !== "月") {
        await this.postGraphData(interval, start, end, graphItemList);
      } else {
        await this.postGraphData(interval, this.monthToDateTimeLocal(start), this.monthToDateTimeLocal(end), graphItemList);
      }
      let datasets = this.createDatasets();
      this.chartData = {
        labels: labels,
        datasets: datasets
      };

      /* 天気の表示 */
      if (this.weatherEnableIntervalList.includes(this.selectInterval)) {
        arguments;
      }
    },
  }
};
</script>
<style scoped>
/* グラフ画面全体 */
.multi-circuit-ef--inner {
  width: 92vw;
  margin: 0 auto;
  margin-bottom: 20px;
  position: relative;
}

.graph-header-caption {
  color: #FFFFFF;
  font-size: 18px;
  line-height: 45px;
}

/* 自動更新ボタン */
.graph-header-button .bt-enable {
  display: inline-block;
  background-color: #e2211a;
  border-radius: 20px;
  padding: 4px 14px;
  color: #ffffff;
}

.graph-header-button .bt-enable:hover {
  opacity: 0.8;
}

/* 自動更新ボタンのツールチップ */
.auto-update-tooltip {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.auto-update-tooltip-description {
  display: none;
  position: absolute;
  padding: 6px;
  font-size: 12px;
  line-height: 1.6em;
  color: #fff;
  border-radius: 5px;
  background: #000;
  width: 140px;
  opacity: 0.75;
  white-space: nowrap;
}

.auto-update-tooltip-description:before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  border: 7px solid transparent;
  border-top: 7px solid #000;
  margin-left: -5px;
}

.auto-update-tooltip:hover .auto-update-tooltip-description {
  display: inline-block;
  top: -40px;
  left: -35px;
}


/* グラフグループ選択 */
.multi-circuit-graph-list {
  background-color: #bcd8ee;
  padding: 10px 15px;
  display: flex;
  align-items: center;
}

.multi-circuit-graph-list p {
  margin: 5px 10px;
}

.multi-circuit-graph-list select {
  border: 1px solid #5ca1d6;
  padding: 5px auto;
  -webkit-appearance: none;
  appearance: none;
  position: relative;
  cursor: pointer;
  outline: none;
}

.multi-circuit-graph-list select::-ms-expand {
  display: none;
}

.multi-circuit-graph-list span {
  margin: 0 5px;
}

.multi-circuit-graph-list .select-box::before {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 100%;
  content: "";
  background-color: #9fc8e7;
  pointer-events: none;
  z-index: 99;
}

.multi-circuit-graph-list .select-box::after {
  position: absolute;
  top: -4px;
  bottom: 0;
  right: 6px;
  margin: auto;
  content: "";
  vertical-align: middle;
  width: 8px;
  height: 8px;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
  z-index: 99;
}

/* 表示単位 */
.display-interval {
  padding: 5px;
  margin: 5px 0;
  display: flex;
  align-items: center;
}

.display-interval p {
  margin: 0 5px;
}

.display-interval .select-display-interval {
  margin: 0 5px;
}

.display-interval .select-display-interval input {
  margin: 0 0 0 0.25em;
  position: relative;
  top: 2px;
}

.display-interval .select-display-interval label {
  margin: 0 0.25em 0 0;
}

/* 表示単位 説明 */
#display-interval-detail {
  margin: 0 50px;
  font-size: xx-small;
}

/* 表示範囲 */
.display-period {
  border-bottom: 1px solid #ddd;
  padding: 5px 5px 10px 5px;
  margin: 6px 0;
  display: flex;
  align-items: center;
}

.display-period p {
  margin: 0 5px;
}

.display-period .select-date {
  margin: 0 10px;
  display: flex;
  align-items: center;
}

.display-period .select-date input {
  border-top: 1px solid #5ca1d6;
  border-bottom: 1px solid #5ca1d6;
}

/* 表示範囲 ボタン */
.bt-period-enable {
  display: inline-block;
  background-color: #5ca1d6;
  border-radius: 3px;
  margin: 0 0.25em;
  padding: 1px 10px;
  color: #ffffff;
  font-size: small;
}

.bt-period-disable {
  display: inline-block;
  background-color: #91a1af;
  border-radius: 3px;
  margin: 0 0.25em;
  padding: 1px 10px;
  color: #ffffff;
  font-size: small;
}

.bt-period-inactive {
  pointer-events: none;
  display: inline-block;
  background-color: #dddddd;
  border-radius: 3px;
  margin: 0 0.25em;
  padding: 1px 10px;
  color: #ffffff;
  font-size: small;
}

.bt-period-enable:hover,
.bt-period-disable:hover {
  background-color: #005cc0;
}

/* 表示範囲 カレンダー */
.bt-date {
  background-color: #5ca1d6;
  border: 1px solid #5ca1d6;
  color: #fff;
  padding: 1px 1px;
}

.bt-date:hover {
  background-color: #005cc0;
}

/* 気象情報 */
.weather {
  width: initial;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.weather li {
  width: 36px;
}

.weather li:first-child {
  margin-left: 2px;
}

.weather li:not(:last-child) {
  margin-right: 14px;
}

.weather li dt img {
  width: 100%;
}

.weather li dd {
  font-size: 10px;
}

.weather li dd.high {
  color: #ec464c;
}

.weather li dd.low {
  color: #488cf0;
}

.weather li dd span {
  font-size: 16px;
}
</style>
